<template>
  <BreadCrumb PageTitle="Ajouter les villes" />
  <AddCityZone  />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import AddCityZone from "@/components/Generals/Zones/AddCityZone.vue";

import { useRoute } from "vue-router";
export default defineComponent({
  name: "AddCityZonePage",
  components: {
    BreadCrumb,
    AddCityZone,
  },

  setup: () => {
    const route = useRoute();
    let id = route.params.id; 
    if (Array.isArray(id)) {
      id = id[0] ?? "";
    }


    return { id };
}
});
</script>